// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2dxip","ranges":"BmiRanges_ranges__2gc0M"};